//Import Libraries
import React, { useEffect, useMemo } from "react";
import "bootstrap/dist/css/bootstrap.css";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useState } from "react";
import { withRouter } from "react-router";
import Button from "@material-ui/core/Button";
import { updateAlert, updateSourceInputs } from "../../../redux/actions";
import LayoutTopSideBottom from "../../../layouts/LayoutTopSideBottom/LayoutTopSideBottom";
import Breadcrumbs from "../../../components/Breadcrumbs/Breadcrumbs";
import EditableTableRetailer from "./EditableTableRetailer";
import fieldsArr from "../fields";
import "../rociview.scss";
import { config } from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import MetaSearchFilter from "./MetaSearchFilter";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useUserAuthentication } from "../../../utils/utils";
import { ApprovalButton } from "../../../components/Approval/ApprovalButton";
import { ApprovalTable } from "../../../components/Approval/ApprovalTable";
import { useHistory } from "react-router-dom";

let api = config.api.api_url;
// let api = process.env.REACT_APP_BACKEND_BASE_URL;

function RetailView(props) {
  const { user, match, updateSourceInputs, updateAlert, source_data } = props;

  // STATES
  const [loading, setLoading] = useState(true);
  const [tableLoading, setTableLoading] = useState(true);
  const [isTableDataSaving, setIsTableDataSaving] = useState(false);
  const [isSearchFilterLoading, setIsSearchFilterLoading] = useState(false);
  const [initial, setInitial] = useState(true);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [isEdit, setIsEdit] = useState(false);
  const [globalEdit, setGlobalEdit] = useState(false);
  const [isFileUploading, setIsFileUploading] = useState(false);
  const [isSaveDialogOpen, setIsSaveDialogOpen] = useState(false);
  const [isCancelDialogOpen, setIsCancelDialogOpen] = useState(false);
  const [isApproval, setIsApproval] = useState(false);
  let history = useHistory();
  const { login } = useUserAuthentication();

  // FUNCTIONS
  async function getSources() {
    const params = new URLSearchParams({
      dataset_name: "Retailer_mapping",
    });
    try {
      // code for initial data fetching
      const response = await fetch(
        api + `/retailer_mapping/getmetadata?${params}`,
        {
          method: "GET",
          mode: "cors",
          credentials: "include",
          headers: {
            Authorization: `Bearer ${user.token || ""}`,
            "Content-Type": "application/json",
          },
        }
      );

      const jsonData = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (jsonData?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }
      if (!jsonData || !jsonData.data) {
        throw new Error("Unexpected error occured. Please try again later");
      }
      const responseData = jsonData.data;
      const { SOURCE, COUNTRY, ...rest } = responseData;

      const DATASETS = SOURCE.map((item) => ({
        label: item,
        value: item,
      }));

      const countryOptions = COUNTRY.map((country) => ({
        label: country.COUNTRY,
        value: country.country_code,
      }));

      updateSourceInputs("current_mapped_source", DATASETS);
      updateSourceInputs("current_mapped_country", countryOptions);
      updateSourceInputs("data", {
        dropdown: rest,
      });
    } catch (err) {
      updateAlert({
        open: true,
        message: `Unexpected error occured. Please try again later`,
        severity: "success",
        closeFlag: true,
      });
    } finally {
      setLoading(false);
    }
  }

  const clearReduxState = () => {
    updateSourceInputs("data", []);
    updateSourceInputs("checked_rows_count", 0);
    updateSourceInputs("current_bussines_unit", "");
    updateSourceInputs("current_dimension", {});
    updateSourceInputs("dimensions_list", []);
    updateSourceInputs("current_source", "");
    updateSourceInputs("current_source_label", "");
    updateSourceInputs("current_target_gold_layer", "");
    updateSourceInputs("current_country", "");
    updateSourceInputs("current_country_code", "");
    updateSourceInputs("current_cmu", "");
    updateSourceInputs("current_category", "");
    updateSourceInputs("current_ssfFileId", "");
    updateSourceInputs("current_filter_value", "");
    updateSourceInputs("current_template_filter_value", "");
    updateSourceInputs("current_template_ssfFileId", "");
    updateSourceInputs("current_table_name", "");
    updateSourceInputs("is_initial", true);
    updateSourceInputs("is_table_loading", true);
    updateSourceInputs("searchValue", "");
    updateSourceInputs("any_row_isEditing", false);
    updateSourceInputs("isFileUploaded", false);
    updateSourceInputs("isNewDataInserted", false);
    updateSourceInputs("current_bussines_unit_list", []);
    updateSourceInputs("current_mapped_source", []);
    updateSourceInputs("current_target_gold_layer_list", []);
    updateSourceInputs("current_mapped_country", []);
    updateSourceInputs("master_table_countries", []);
    updateSourceInputs("current_ssf_file_id", []);
    updateSourceInputs("current_template_ssf_file_id", []);
    updateSourceInputs("current_category_data", []);
    updateSourceInputs("current_mapped_data", []);
    updateSourceInputs("current_mapped_data_main", []);
    updateSourceInputs("modified_mapped_data", []);
    updateSourceInputs("current_filters", []);
    updateSourceInputs("appliedFilters", []);
    updateSourceInputs("download_sample_file", []);
    updateSourceInputs("filtered_Rows", []);
    updateSourceInputs("current_columns", []);
    updateSourceInputs("actualData", []);
    updateSourceInputs("recommendedModel", []);
    updateSourceInputs("approvalData", []);
    updateSourceInputs("approvalTable_Header", []);
  };

  const getData = (row) => {};

  const outlinedCNCButton = {
    borderColor: "#46596A",
    // background-color: #d7dadd,
    color: "#46596A",
    // width: '100%',
    fontFamily: "Hind Siliguri",
    fontSize: "12px",
    fontWeight: "bold",
    marginRight: "5px",
  };

  const containedButton = {
    color: "white",
    backgroundColor: "#46596A",
    fontFamily: "Hind Siliguri",
    fontSize: "12px",
    fontWeight: "bold",
    // marginLeft: "10px !important",
    marginRight: "5px",
  };

  const IS_ANY_ROWDATA_NULL = useMemo(() => {
    if (
      source_data.current_mapped_data &&
      source_data.current_mapped_data.length > 0 &&
      source_data.data.dropdown
    ) {
      const ExceptionKeys = [...source_data.data.dropdown.metadata_filter];

      return source_data?.current_mapped_data.some((singleRowData) => {
        return Object.keys(singleRowData.rowData).every(
          (key) =>
            ExceptionKeys.includes(key) || singleRowData.rowData[key] === null
        );
      });
    } else {
      return false;
    }
  }, [
    source_data.current_mapped_data,
    source_data.current_ssfFileId,
    source_data.current_filter_value,
  ]);

  const IS_ANY_RECORDS_EDITED = useMemo(
    () =>
      source_data?.current_mapped_data?.some(
        (item) => item.isEdited === true
      ) ?? false,
    [source_data.current_mapped_data]
  );

  const is_Approver = useMemo(() => {
    const Is_Role_Approver = user?.role && user?.role?.includes("AppApprover");
    const URL = history?.location?.pathname || [];
    const result = URL.split("/").pop();
    const is_Approver_For_This_Usecase =
      user?.approval_screens && user?.approval_screens?.includes(result);
    return Is_Role_Approver && is_Approver_For_This_Usecase;
  }, [user.role, user.approval_screens]);

  //function to set page for changing table row
  const pageChange = (event, value) => {
    setPage(value);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  let page_props = {
    total: source_data.current_mapped_data
      ? Math.ceil(source_data.current_mapped_data.length / rowsPerPage)
      : 0,
    page: page,
    changePage: pageChange,
    rowsPerPage: rowsPerPage,
    handleChangeRowsPerPage: handleChangeRowsPerPage,
    show_pageOptions: true,
  };

  function cancelFunction() {
    setIsCancelDialogOpen(false);
    // updateSourceInputs("data",[]);
    updateSourceInputs("current_source", "");
    updateSourceInputs("current_country", "");
    updateSourceInputs("current_cmu", "");
    updateSourceInputs("current_table_name", "");
    updateSourceInputs("current_mapped_source", []);
    updateSourceInputs("current_mapped_country", []);
    updateSourceInputs("current_mapped_data", []);
    updateSourceInputs("current_filter_value", "");
    updateSourceInputs("modified_mapped_data", []);
    updateSourceInputs("any_row_isEditing", false);
    setInitial(true);
    updateSourceInputs("is_initial", true);
    getSources();
  }

  function mergeWithObj2Priority(obj1, obj2) {
    const commonKeys = Object.keys(obj1).filter((key) => key in obj2);

    if (commonKeys.length > 0) {
      // Merge and overwrite obj1 values with obj2 values for common keys
      return {
        ...obj1,
        ...obj2, // obj2 values take priority
      };
    } else {
      // No common keys – just merge all keys
      return {
        ...obj1,
        ...obj2,
      };
    }
  }

  const getSortedModifiedData = () => {
    const Temp_Modidified_Data = source_data.modified_mapped_data.map(
      (item) => {
        if (source_data.current_source === "Nielsen") {
          return {
            ...item,
            isEdited: "true",
            updated: {
              ...item.updated,
              COUNTRY_CODE: source_data.current_country_code,
              CREATED_BY: item.isNew
                ? user.mail || ""
                : item.updated.CREATED_BY || "",
              UPDATED_BY: !item.isNew
                ? user.mail || ""
                : item.updated.UPDATED_BY || "",
            },
          };
        } else {
          const { COUNTRY_CODE, ...rest } = item.updated;
          return {
            ...item,
            isEdited: "true",
            updated: {
              ...rest,
              CREATED_BY: item.isNew
                ? user.mail || ""
                : item.updated.CREATED_BY || "",
              UPDATED_BY: !item.isNew
                ? user.mail || ""
                : item.updated.UPDATED_BY || "",
            },
          };
        }
      }
    );

    // Merge the Actual and updated object of modified data
    const Temp_modified_data_map = source_data.modified_mapped_data.map(
      (item) => {
        return mergeWithObj2Priority(item.actual, item.updated);
      }
    );

    const Current_Mapped_Data_With_Country_Code =
      source_data.current_mapped_data.map((item) => {
        return {
          ...item,
          rowData: {
            ...item.rowData,
            COUNTRY_CODE: source_data.current_country_code,
          },
        };
      });

    // Remove the the data which is modified from the current mapped data
    const Changed_Rows_Removed_Data =
      Current_Mapped_Data_With_Country_Code.filter((item) => {
        const isDuplicate = Temp_modified_data_map.some((data) =>
          source_data.data.dropdown.duplicate_validation_attributes.every(
            (attribute) => item.rowData[attribute] === data[attribute]
          )
        );

        // Keep only if it's NOT a duplicate
        return !isDuplicate;
      });

    // Structure the Changed_Rows_Removed_Data
    const Temp_UnChanged_Data_Two = Changed_Rows_Removed_Data.map((item) => {
      return {
        isNewData: item.isNewData,
        actual: item.rowData,
        updated: item.rowData,
        isEdited: "false",
      };
    });

    const MODIFIED_MAPPED_DATA = [
      ...Temp_Modidified_Data,
      ...Temp_UnChanged_Data_Two,
    ];

    // Sorting MODIFIED_MAPPED_DATA by making null as String (i., "null")
    const SORTED_MODIFIED_MAPPED_DATA = MODIFIED_MAPPED_DATA.map((item) => {
      const KEYS = Object.keys(item.updated);
      const Actual = {};
      const Updated = {};

      KEYS.forEach((key) => {
        if (!item.isNewData) {
          Actual[key] = item.actual[key] === null ? "null" : item.actual[key];
        }
        Updated[key] = item.updated[key] === null ? "null" : item.updated[key];
      });

      return {
        actual: Actual,
        updated: Updated,
        isEdited: item.isEdited,
      };
    });

    return SORTED_MODIFIED_MAPPED_DATA;
  };

  // Function with Mock Data for Calculated Expression validation Flow
  const onSave = async () => {
    setIsTableDataSaving(true);
    // Getting The MODIFIED_MAPPED_DATA with IS_EDITED ATTRIBUTE
    let MODIFIED_MAPPED_DATA;
    if (source_data.current_filter_value === "Existing") {
      MODIFIED_MAPPED_DATA = getSortedModifiedData();
    } else {
      const Temp_Modidified_Data = source_data.modified_mapped_data.map(
        (item) => {
          return {
            actual: {},
            updated: item.updated,
            isEdited: "true",
            isNew: true,
          };
        }
      );

      const Sorted_Data = Temp_Modidified_Data.map((item) => {
        const KEYS = Object.keys(item.updated);
        const Updated = {};

        KEYS.forEach((key) => {
          Updated[key] =
            item.updated[key] === null ? "null" : item.updated[key];
        });

        return {
          actual: {},
          updated: {
            ...Updated,
            COUNTRY: source_data.current_country,
            COUNTRY_CODE: source_data.current_country_code,
            SOURCE: source_data.current_source,
            CREATED_BY: user.mail,
          },
          isEdited: item.isEdited,
        };
      });

      MODIFIED_MAPPED_DATA = Sorted_Data.map((item) => {
        if (source_data.current_source === "Nielsen") {
          return item;
        } else {
          const { COUNTRY_CODE, ...rest } = item.updated;
          return {
            ...item,
            updated: {
              ...rest,
            },
          };
        }
      });
    }

    try {
      const params = new URLSearchParams({
        dataset_name: "Retailer_mapping",
      });
      const response = await fetch(
        api + `/retailer_mapping/updatetabledata?${params}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${user.token || ""}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(MODIFIED_MAPPED_DATA),
          credentials: "include",
        }
      );
      updateAlert({
        open: true,
        message: "Validating the records",
        severity: "success",
        closeFlag: true,
      });

      const data = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      if (data.data === "Update/Insert Query executed successfully") {
        updateSourceInputs("current_source", "");
        updateSourceInputs("current_country", "");
        updateSourceInputs("current_filter_value", "");
        updateSourceInputs("current_mapped_source", []);
        updateSourceInputs("current_mapped_country", []);
        updateSourceInputs("current_mapped_data", []);
        updateSourceInputs("modified_mapped_data", []);
        getSources();
        setInitial(true);
        updateSourceInputs("is_initial", true);
        setGlobalEdit(false);
        setTableLoading(false);
        updateSourceInputs("is_table_loading", false);

        // Toast OnSuccess
        updateAlert({
          open: true,
          message: "Mapping data updated successfully",
          severity: "success",
          closeFlag: true,
        });
      } else {
        // RESPONSE DATA FROM BACKEND API
        const Response = data.validated_result;

        // STEP 1 = UPDATE CURRENT_MAPPED_DATA RECORDS WITH RESPECTIVE RECORD FROM ACTUAL_UPDATED_COMBINED_DATA
        const Sorted_Mapped_Data = source_data.current_mapped_data.map(
          (item) => {
            // COMPARE MAPPED_DATA WITH RESPONSE DATA AND UPDATE ITS IS_VALIDATED ATTRIBUTE
            const matchedData = Response.find((data) => {
              const Merged_Data =
                source_data.current_filter_value === "Existing"
                  ? mergeWithObj2Priority(data.actual, data.updated)
                  : data.updated;
              // Check if all duplicate validation attributes match
              return source_data.data.dropdown.duplicate_validation_attributes.every(
                (attribute) => {
                  return item.rowData[attribute] === Merged_Data[attribute];
                }
              );
            });

            return {
              ...item,
              isEdited: matchedData
                ? matchedData.isEdited === "true"
                  ? true
                  : false
                : item.isEdited,
              isValidated: matchedData
                ? matchedData.isValidation === "true"
                  ? true
                  : false
                : item.isValidated,
              errorMessage:
                matchedData.isValidation === "false"
                  ? matchedData.exception_details
                  : "",
            };
          }
        );

        // STEP 2 = SORTING THE Sorted_Mapped_Data By keeping the Items with isValidated = false at top
        const FINAL_SORTED_MAPPED_DATA = Sorted_Mapped_Data.sort((a, b) => {
          return a.isValidated - b.isValidated;
        });

        updateSourceInputs("current_mapped_data", FINAL_SORTED_MAPPED_DATA);

        // Error Toast
        updateAlert({
          open: true,
          message: "There was an error in the expression validation",
          severity: "Failed ",
          closeFlag: true,
        });
      }
    } catch (err) {
      updateAlert({
        open: true,
        message: `Unexpected error occured. Please try again later`,
        severity: "Failed ",
        closeFlag: true,
      });
    }

    setIsTableDataSaving(false);
    setIsSaveDialogOpen(false);
  };

  const setMappedData = async (dataset, country, filter) => {
    setInitial(false);
    updateSourceInputs("is_initial", false);
    setGlobalEdit(false);
    setTableLoading(true);
    updateSourceInputs("is_table_loading", true);
    setIsSearchFilterLoading(true);

    let filteredDatasetValue;
    let tableData;

    // const Meta_Filters = source_data.data.dropdown.metadata_filter;

    if (filter === "Existing") {
      try {
        const params = new URLSearchParams({
          source: dataset || "",
          country: country || "",
          filtertype: "initial_fetch",
          dataset_name: "Retailer_mapping",
        });
        const response = await fetch(
          api + `/retailer_mapping/fetchtabledata?${params}`,
          {
            method: "GET",
            mode: "cors",
            credentials: "include",
            headers: {
              Authorization: `Bearer ${user.token || ""}`,
              "Content-Type": "application/json",
            },
          }
        );
        const data = await response.json();

        // Check if response is OK before trying to parse it
        if (!response.ok) {
          if (data?.statusCode === "harbor-401") {
            updateAlert({
              open: true,
              message: `User Unauthorized. Please sign in.`,
              severity: "warning",
              closeFlag: true,
            });
            login(); // or redirect to login
            return;
          } else {
            throw new Error(`Unexpected error occured. Please try again later`);
          }
        }

        if (data && data.data) {
          filteredDatasetValue = data.data;
        }
      } catch (err) {
        updateAlert({
          open: true,
          message: `Unexpected error occured. Please try again later`,
          severity: "Failed ",
          closeFlag: true,
        });
      }

      let val = filteredDatasetValue;
      let ITEM_ID = 0;
      tableData =
        val &&
        val.map((item) => {
          const rowData = {
            item_Id: ITEM_ID,
            isEditing: false,
            isNewData: false,
            isEdited: false,
            isValidated: true,
            isCheckedRow: false,
            errorMessage: "",
            rowData: item,
          };
          ITEM_ID++;
          return rowData;
        });
    }

    // TABLE_DROPDOWN_DATA
    updateSourceInputs("current_mapped_data", tableData);
    setLoading(false);
    setTableLoading(false);
    updateSourceInputs("is_table_loading", false);
    setIsSearchFilterLoading(false);
  };

  const setMappedDataCreateNew = async (country, country_code) => {
    setInitial(false);
    updateSourceInputs("is_initial", false);
    setGlobalEdit(false);
    setTableLoading(true);
    updateSourceInputs("is_table_loading", true);
    setIsSearchFilterLoading(true);

    let tableData;

    // const Meta_Filters = source_data.data.dropdown.metadata_filter;

    let InsertNewTableData;
    try {
      const params = new URLSearchParams({
        dataset_name: "New_retailer_mapping",
      });
      const response = await fetch(
        api + `/retailer_mapping/getmetadata?${params}`,
        {
          method: "GET",
          mode: "cors",
          credentials: "include",
          headers: {
            Authorization: `Bearer ${user.token || ""}`,
            "Content-Type": "application/json",
          },
        }
      );
      const data = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }
      if (data && data.data) {
        InsertNewTableData = data.data;
      }

      const val = InsertNewTableData.New_retailer_mapping;
      let ITEM_ID = 0;
      tableData =
        val &&
        val.map((item) => {
          let rowData = {};
          if (source_data.current_source === "Nielsen") {
            rowData = {
              item_Id: ITEM_ID,
              isEditing: false,
              isNewData: false,
              isEdited: false,
              isValidated: true,
              isCheckedRow: false,
              errorMessage: "",
              rowData: {
                ...item,
                COUNTRY: country,
                COUNTRY_CODE: country_code,
                SOURCE: source_data.current_source,
              },
            };
          } else {
            rowData = {
              item_Id: ITEM_ID,
              isEditing: false,
              isNewData: false,
              isEdited: false,
              isValidated: true,
              isCheckedRow: false,
              errorMessage: "",
              rowData: {
                ...item,
                COUNTRY: country,
                SOURCE: source_data.current_source,
              },
            };
          }
          ITEM_ID++;
          return rowData;
        });

      const SAMPLE_DOWNLOAD_FILE =
        val &&
        val.map((item) => {
          let rowData = { ...item };
          Object.keys(rowData).forEach((key) => {
            if (
              rowData[key] === "null" ||
              rowData[key] === undefined ||
              rowData[key] === null
            ) {
              rowData[key] = null;
            }
          });
          const Altered_RowData = rowData;

          if (source_data.current_source === "Nielsen") {
            rowData = {
              ...Altered_RowData,
              COUNTRY: country,
              COUNTRY_CODE: country_code,
              SOURCE: source_data.current_source,
            };
          } else {
            rowData = {
              ...Altered_RowData,
              COUNTRY: country,
              SOURCE: source_data.current_source,
            };
          }
          return rowData;
        });

      const MODIFIED_MAPPED_DATA = tableData.map((rowData) => {
        return {
          actual: {},
          updated: rowData.rowData,
          isNew: true,
          isEdited: false,
        };
      });
      updateSourceInputs("download_sample_file", SAMPLE_DOWNLOAD_FILE);
      updateSourceInputs("modified_mapped_data", MODIFIED_MAPPED_DATA);
    } catch (err) {
      updateAlert({
        open: true,
        message: `Unexpected error occured. Please try again later`,
        severity: "Failed ",
        closeFlag: true,
      });
    }

    // TABLE_DROPDOWN_DATA
    updateSourceInputs("current_mapped_data", tableData);
    setLoading(false);
    setTableLoading(false);
    updateSourceInputs("is_table_loading", false);
    setIsSearchFilterLoading(false);
  };

  const handleCreateNewRow = () => {
    setIsSearchFilterLoading(true);
    updateSourceInputs("appliedFilters", []);
    updateSourceInputs("searchValue", "");
    updateSourceInputs("filtered_Rows", []);
    let filteredDatasetValue;
    let tableData;

    const CURRENT_MAPPED_DATA = source_data.current_mapped_data;
    let NewRowData = source_data.data.dropdown.insert_column_attributes;
    NewRowData = {
      ...NewRowData,
      COUNTRY: source_data.current_country,
      SOURCE: source_data.current_source,
    };
    filteredDatasetValue = [NewRowData, ...CURRENT_MAPPED_DATA];

    let val = filteredDatasetValue;
    let ITEM_ID = 0;
    tableData =
      val &&
      val.map((item) => {
        let rowData;
        if (item.rowData) {
          rowData = {
            ...item,
            item_Id: ITEM_ID,
          };
        } else {
          rowData = {
            item_Id: ITEM_ID,
            isEditing: true,
            isNewData: true,
            isEdited: false,
            isValidated: true,
            isCheckedRow: false,
            errorMessage: "",
            rowData: item,
          };
        }
        ITEM_ID++;
        return rowData;
      });

    // // TABLE_DROPDOWN_DATA
    updateSourceInputs("any_row_isEditing", true);
    updateSourceInputs("current_mapped_data", tableData);
    updateSourceInputs("isNewDataInserted", true);
    updateSourceInputs("appliedFilters", []);
    updateSourceInputs("searchValue", "");
    updateSourceInputs("filtered_Rows", []);
    setIsSearchFilterLoading(false);
  };

  const handleSourceInput = (data, selectedRowsCount) => {
    updateSourceInputs("current_mapped_data", data);
    updateSourceInputs("checked_rows_count", selectedRowsCount);
  };

  const handleValidateFileData = (tableData) => {
    updateAlert({
      open: true,
      message: "Validating row data's",
      severity: "success",
      closeFlag: true,
    });

    const Current_Table_Data = tableData;
    const TABLE_HEAD_COLUMN_LIST =
      source_data.data.dropdown.table_header_column_list;
    const EDIT_COLUMN_LIST = source_data.data.dropdown.edit_model_column_list;
    const Mapping_Type_Field_Details =
      source_data?.data?.dropdown?.mapping_type_field_details || [];

    const isValid = Current_Table_Data.every((item) => {
      return TABLE_HEAD_COLUMN_LIST.every((column) => {
        if (
          !source_data?.data?.dropdown?.duplicate_validation_attributes?.includes(
            column.name
          ) &&
          (item.rowData?.[column.name] ||
            item.rowData[column.name] === "null" ||
            item.rowData[column.name] === "" ||
            item.rowData[column.name] === null ||
            item.rowData[column.name]?.length === 0)
        ) {
          return true;
        }

        if (
          column.name === "HARBOR_VALUE" &&
          Mapping_Type_Field_Details &&
          Mapping_Type_Field_Details.length > 0 &&
          Mapping_Type_Field_Details?.includes(item.rowData.MAPPING_TYPE)
        ) {
          return true;
        }

        if (column.is_dependent) {
          const Filtered_Dropdown_Data = source_data.data.dropdown[column.name];
          const Parent_Column_Name = column.parent_column;
          const Parent_Column_Value = item.rowData[Parent_Column_Name];

          // CHECK IS VALID VALUE
          const Filtered_Final_Options =
            Parent_Column_Value !== null
              ? Filtered_Dropdown_Data.filter(
                  (option) => option[Parent_Column_Name] === Parent_Column_Value
                )
              : [];

          const isValidated = Filtered_Final_Options[0][column.name].includes(
            item.rowData[column.name]
          );

          return isValidated;
        } else {
          let result = EDIT_COLUMN_LIST.find(
            (data) => data.type === "select" && column.name === data.name
          );

          if (result && result.type === "select") {
            const DROPDOWN_DATA_NEW = source_data.data.dropdown;

            let Final_DropDown_Values;
            EDIT_COLUMN_LIST.map((editItem) => {
              if (editItem.name === column.name && editItem.isArray) {
                Final_DropDown_Values = DROPDOWN_DATA_NEW[column.name];
              }
              if (editItem.name === column.name && !editItem.isArray) {
                const BRONZE_TABLE =
                  Object.keys(DROPDOWN_DATA_NEW[column.name]["BRONZE_TABLE"])
                    .length > 0
                    ? DROPDOWN_DATA_NEW[column.name]["BRONZE_TABLE"][
                        item.rowData[editItem.parent_for_dropdown].toUpperCase()
                      ]
                    : [];

                const HEADER_TABLE =
                  Object.keys(DROPDOWN_DATA_NEW[column.name]["HEADER_TABLE"])
                    .length > 0
                    ? DROPDOWN_DATA_NEW[column.name]["HEADER_TABLE"][
                        item.rowData[editItem.parent_for_dropdown].toUpperCase()
                      ]
                    : [];

                Final_DropDown_Values = [
                  ...(Array.isArray(BRONZE_TABLE) && BRONZE_TABLE.length > 0
                    ? BRONZE_TABLE
                    : []),
                  ...(Array.isArray(HEADER_TABLE) && HEADER_TABLE.length > 0
                    ? HEADER_TABLE
                    : []),
                ];
              }
            });

            // UNCOMMENT IF CASE SENSITIVE TEST IS NOT REQUIRED
            // const isValidated = Array.isArray(Final_DropDown_Values) && Final_DropDown_Values.some((option)=> option.toUpperCase() === item.rowData[column.name].toUpperCase() )

            let resultvalid;
            if (
              Array.isArray(Final_DropDown_Values) &&
              Final_DropDown_Values.length === 0
            ) {
              resultvalid = true;
            } else {
              resultvalid = Final_DropDown_Values.includes(
                item.rowData[column.name]
              );
            }

            return resultvalid;
          } else {
            return true;
          }
        }
      });
    });

    if (isValid) {
      updateAlert({
        open: true,
        message: "File data validated successfully",
        severity: "success",
        closeFlag: true,
      });
      setIsFileUploading(false);
      const MODIFIED_MAPPED_DATA = Current_Table_Data.map((item) => {
        return {
          actual: {},
          isNew: false,
          isEdited: true,
          updated: { ...(item?.rowData || {}) },
        };
      });

      updateSourceInputs("modified_mapped_data", MODIFIED_MAPPED_DATA);
      updateSourceInputs("current_mapped_data", tableData);
      updateSourceInputs("is_table_loading", false);
      updateSourceInputs("isFileUploaded", true);
    } else {
      updateSourceInputs("is_initial", true);
      updateAlert({
        open: true,
        message: "Validation Failed, Please check the Record and try again",
        severity: "success",
        closeFlag: true,
      });
    }

    setIsFileUploading(false);
  };

  const validateMetaSelectionColumns = (tdata) => {
    let hasValidValuesForMetaColumns = { status: false, errorMessage: "" };
    tdata?.forEach((item) => {
      if (
        !item["COUNTRY"] ||
        item["COUNTRY"] === "" ||
        item["COUNTRY"] === null ||
        item["COUNTRY"] === undefined
      ) {
        hasValidValuesForMetaColumns = {
          status: true,
          errorMessage: "Invalid country value found in the uploaded file.",
        };
        return;
      }
      if (
        source_data?.current_source.toLowerCase() === "nielsen" &&
        (!item["COUNTRY_CODE"] ||
          item["COUNTRY_CODE"] === "" ||
          item["COUNTRY_CODE"] === null ||
          item["COUNTRY_CODE"] === undefined)
      ) {
        hasValidValuesForMetaColumns = {
          status: true,
          errorMessage:
            "Invalid country code value found in the uploaded file.",
        };
        return;
      }
      if (
        !item["SOURCE"] ||
        item["SOURCE"] === "" ||
        item["SOURCE"] === null ||
        item["SOURCE"] === undefined
      ) {
        hasValidValuesForMetaColumns = {
          status: true,
          errorMessage: "Invalid source value found in the uploaded file.",
        };
        return;
      }

      if (item["COUNTRY"] !== source_data?.current_country) {
        hasValidValuesForMetaColumns = {
          status: true,
          errorMessage: "Invalid country value found in the uploaded file.",
        };
        return;
      }
      if (
        source_data?.current_source.toLowerCase() === "nielsen" &&
        item["COUNTRY_CODE"] !== source_data?.current_country_code
      ) {
        hasValidValuesForMetaColumns = {
          status: true,
          errorMessage:
            "Invalid country code value found in the uploaded file.",
        };
        return;
      }
      if (item["SOURCE"] !== source_data?.current_source) {
        hasValidValuesForMetaColumns = {
          status: true,
          errorMessage: "Invalid source value found in the uploaded file.",
        };
        return;
      }
      hasValidValuesForMetaColumns = { status: false, errorMessage: "" };
    });
    return hasValidValuesForMetaColumns;
  };

  const handleFileUpload = (records) => {
    updateSourceInputs("is_initial", false);
    updateSourceInputs("is_table_loading", true);
    setIsFileUploading(true);

    const Current_Table_Data = records || [];
    const validationResult = validateMetaSelectionColumns(Current_Table_Data);

    if (validationResult && validationResult.status) {
      updateSourceInputs("isFileUploaded", false);
      updateSourceInputs("is_file_uploaded", false);
      updateSourceInputs("is_initial", true);
      setIsFileUploading(false);
      updateAlert({
        open: true,
        message: `Validation Failed. ${
          validationResult?.errorMessage || "Please check the uploaded file."
        }`,
        severity: "warning",
        closeFlag: true,
      });
      return;
    }

    const Meta_Filters = source_data.data.dropdown.metadata_filter;
    const Existing_Records = source_data.current_mapped_data;
    const XL_FILE_RECORDS = records.map((item) => {
      return {
        ...item,
        [Meta_Filters[1]]: source_data.current_ssfFileId || "",
        CREATED_AT: item.CREATED_AT || null,
        CREATED_BY: item.CREATED_BY || null,
        UPDATED_AT: item.UPDATED_AT || null,
        UPDATED_BY: item.UPDATED_BY || null,
      };
    });

    const FILTEREDRECORDS = XL_FILE_RECORDS.map((item, i) => {
      const existing_Data = Existing_Records?.[i];
      return { ...(existing_Data?.rowData || {}), ...item };
    });

    let ITEM_ID = 0;
    const tableData =
      FILTEREDRECORDS &&
      FILTEREDRECORDS.map((item) => {
        const rowData = {
          item_Id: ITEM_ID,
          isEditing:
            typeof item.isEditing === "boolean" ? item.isEditing : false,
          isNewData:
            typeof item.isNewData === "boolean" ? item.isNewData : false,
          isEdited: typeof item.isEdited === "boolean" ? item.isEdited : false,
          isValidated:
            typeof item.isValidated === "boolean" ? item.isValidated : true,
          isCheckedRow:
            typeof item.isCheckedRow === "boolean" ? item.isCheckedRow : false,
          errorMessage: "",
          rowData: item.rowData ? item.rowData : item,
        };
        ITEM_ID++;
        return rowData;
      });

    handleValidateFileData(tableData);
  };

  const handleDialogClose = () => {
    if (!isTableDataSaving) {
      setIsSaveDialogOpen(false);
    }
  };

  const handleDialogOpen = () => {
    setIsSaveDialogOpen(true);
  };

  const getApprovalData = async () => {
    clearReduxState();
    setLoading(true);
    try {
      const params = new URLSearchParams({
        usecase_name: "global_retailer_mapping",
        user_name: user.mail || "",
      });
      const response = await fetch(
        api + `/approval/getapprovaldata?${params}`,
        {
          method: "GET",
          mode: "cors",
          credentials: "include",
          headers: {
            Authorization: `Bearer ${user.token || ""}`,
            "Content-Type": "application/json",
          },
        }
      );
      // Check if response is OK before trying to parse it
      if (!response.ok) {
        throw new Error(`API returned status ${response.status}`);
      }

      const data = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      if (!data || !data.data) {
        throw new Error("Unexpected error occured. Please try again later");
      }

      updateSourceInputs("approvalData", data.data);
      updateSourceInputs(
        "approvalTable_Header",
        data?.metadata?.table_headers || []
      );
    } catch (err) {
      updateAlert({
        open: true,
        message: `Unexpected error occured. Please try again later`,
        severity: "success",
        closeFlag: true,
      });
    } finally {
      setLoading(false);
    }
  };

  // CONSTANTS
  const SOURCE_DATASET_LIST =
    source_data?.current_mapped_source &&
    source_data?.current_mapped_source.map((data) => {
      return data.toString();
    });

  const SOURCE_DATA_SET_SELECTED =
    SOURCE_DATASET_LIST &&
    SOURCE_DATASET_LIST.map((data) => {
      return { label: data, value: data };
    });

  // USE EFFECTS
  useEffect(() => {
    if (
      source_data.current_category != "" &&
      source_data.current_source != ""
    ) {
      setPage(0);
    }
  }, [source_data.current_source, source_data.current_category]);

  useEffect(() => {
    const fetchData = async () => {
      await getSources();
    };
    fetchData();
  }, []);

  return (
    <>
      <LayoutTopSideBottom match={match}>
        {/* Breadcrumbs and Approval Option */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: is_Approver ? "10px" : "0px",
          }}
        >
          <Breadcrumbs match={match} />
          {is_Approver && (
            <ApprovalButton
              buttonText={
                source_data?.data?.dropdown?.approver_details?.button_text ||
                "Approval"
              }
              getApprovalData={getApprovalData}
              isApproval={isApproval}
              setIsApproval={setIsApproval}
              getSources={getSources}
              isTableDataLoading={
                !source_data.is_initial && source_data.is_table_loading
              }
              any_row_isEditing={source_data?.any_row_isEditing}
              sourceData={source_data}
            />
          )}
        </div>
        {loading ? (
          <Loader />
        ) : isApproval ? (
          <ApprovalTable
            sourceData={source_data}
            user={user}
            login={login}
            updateAlert={updateAlert}
            getApprovalData={getApprovalData}
            usecase_name={"global_retailer_mapping"}
          />
        ) : (
          <MetaSearchFilter
            loading={loading}
            setInitial={setInitial}
            setTableLoading={setTableLoading}
            setLoading={setLoading}
            setMappedData={setMappedData}
            setMappedDataCreateNew={setMappedDataCreateNew}
            isSearchFilterLoading={isSearchFilterLoading}
            tableLoading={source_data.is_table_loading}
            updateAlert={updateAlert}
            handleFileUpload={handleFileUpload}
            isFileUploading={isFileUploading}
            requiredColumns={
              source_data?.data?.dropdown?.insert_column_attributes
            }
          />
        )}

        {/* Loader new code */}
        {!source_data.is_initial ? (
          !source_data.is_table_loading ? (
            <>
              <EditableTableRetailer
                initWithoutHead
                page_props={page_props}
                sourceDropdownData={source_data.data.dropdown}
                defaultData={source_data.current_mapped_data}
                checkedRowCount={source_data.checked_rows_count}
                getData={getData}
                fieldsArr={fieldsArr}
                rowsPerPage={rowsPerPage}
                setIsEdit={setIsEdit}
                setGlobalEdit={setGlobalEdit}
                page={page}
                setPage={setPage}
                setRowsPerPage={setRowsPerPage}
                updateSourceHandler={handleSourceInput}
                sourceDatasetSelected={SOURCE_DATA_SET_SELECTED}
                setIsSearchFilterLoading={setIsSearchFilterLoading}
              />
              {/* Action button and disclaimer */}
              <div>
                <div className="disclaimer">
                  {/* INSERT NEW BUTTON */}
                  <div>
                    <Button
                      disableFocusRipple
                      style={containedButton}
                      onClick={handleCreateNewRow}
                      disabled={isSearchFilterLoading || IS_ANY_ROWDATA_NULL}
                    >
                      <span>Insert new</span>
                    </Button>
                  </div>

                  {/* DISCLAIMER */}
                  <div>
                    {source_data?.data?.dropdown?.disclaimer_details
                      ?.is_Disclaimer_available &&
                      Array.isArray(
                        source_data?.data?.dropdown?.disclaimer_details
                          ?.disclaimer_text
                      ) &&
                      source_data.data.dropdown.disclaimer_details
                        .disclaimer_text.length > 0 && (
                        <div style={{ display: "flex" }}>
                          <p
                            style={{
                              margin: "0px",
                            }}
                          >
                            Disclaimer:
                          </p>
                          <ul
                            style={{
                              listStyle:
                                source_data.data.dropdown.disclaimer_details
                                  .disclaimer_text.length > 1
                                  ? "outside"
                                  : "none",
                              margin: "0px",
                              marginLeft:
                                source_data.data.dropdown.disclaimer_details
                                  .disclaimer_text.length > 1
                                  ? "0px"
                                  : "-15px",
                            }}
                          >
                            {source_data.data.dropdown.disclaimer_details.disclaimer_text.map(
                              (text, idx) => (
                                <li key={idx}>{text}</li>
                              )
                            )}
                          </ul>
                        </div>
                      )}
                  </div>
                </div>

                {/* ACTION BUTTONS */}
                <div className="action-buttons">
                  <div className="">
                    <Button
                      disableFocusRipple
                      variant="outlined"
                      style={outlinedCNCButton}
                      onClick={() => setIsCancelDialogOpen(true)}
                      disabled={isTableDataSaving}
                    >
                      Cancel
                    </Button>

                    {IS_ANY_RECORDS_EDITED && (
                      <Button
                        disableFocusRipple
                        style={containedButton}
                        onClick={handleDialogOpen}
                        disabled={isTableDataSaving}
                      >
                        <span>Save</span>
                      </Button>
                    )}
                  </div>
                </div>
              </div>

              {/* SAVE DIALOG */}
              <div>
                <Dialog
                  fullWidth={true}
                  maxWidth={"sm"}
                  open={isSaveDialogOpen}
                  onClose={handleDialogClose}
                >
                  <DialogTitle>Confirmation</DialogTitle>
                  <DialogContent dividers>
                    <DialogContentText>
                      <p style={{ fontSize: "16px", color: "black" }}>
                        The latest changes will be updated. Do you want to
                        continue?
                      </p>
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button
                      disableFocusRipple
                      variant="outlined"
                      style={outlinedCNCButton}
                      onClick={handleDialogClose}
                      disabled={isTableDataSaving}
                    >
                      Cancel
                    </Button>
                    <Button
                      disableFocusRipple
                      style={containedButton}
                      disabled={isTableDataSaving}
                      onClick={onSave}
                    >
                      Continue
                      {isTableDataSaving && <Loader />}
                    </Button>
                  </DialogActions>
                </Dialog>
              </div>

              {/* CANCEL DIALOG */}
              <div>
                <Dialog
                  fullWidth={true}
                  maxWidth={"sm"}
                  open={isCancelDialogOpen}
                  onClose={() => setIsCancelDialogOpen(false)}
                >
                  <DialogTitle>Confirmation</DialogTitle>
                  <DialogContent dividers>
                    <DialogContentText>
                      <p style={{ fontSize: "16px", color: "black" }}>
                        The latest changes will be undone. Do you want to
                        continue?
                      </p>
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button
                      disableFocusRipple
                      variant="outlined"
                      style={outlinedCNCButton}
                      onClick={() => setIsCancelDialogOpen(false)}
                    >
                      Cancel
                    </Button>
                    <Button
                      disableFocusRipple
                      style={containedButton}
                      onClick={cancelFunction}
                    >
                      Continue
                    </Button>
                  </DialogActions>
                </Dialog>
              </div>
            </>
          ) : (
            <Loader />
          )
        ) : (
          <div style={{ textAlign: "center" }}>
            {/* Choose the above mapping filters */}
          </div>
        )}

        {/* Loader new code end */}
      </LayoutTopSideBottom>

      {/* Table view*/}
    </>
  );
}
RetailView.propTypes = {
  updateAlert: PropTypes.func,
  updateSourceInputs: PropTypes.func,
};

const mapStateToProps = (state) => ({
  user: state.user,
  source_data: state.source,
});

const mapDispatchToProps = {
  updateAlert,
  updateSourceInputs,
};
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(RetailView)
);
